import React from 'react'

const PackageWeightIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                fillRule="evenodd"
                className=""
            >
                <g>
                    <linearGradient
                        id="a"
                        x1={0}
                        x2={1}
                        y1={0}
                        y2={0}
                        gradientTransform="matrix(58 0 0 -58 3 32)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopOpacity={1} stopColor="#f96f9a" offset={0} />
                        <stop stopOpacity={1} stopColor="#fde040" offset={1} />
                    </linearGradient>
                    <path
                        fill="url(#a)"
                        d="M3 57v-6a3 3 0 0 1 3-3h42V21.487c-3.494-1.237-6-4.572-6-8.487 0-4.967 4.033-9 9-9s9 4.033 9 9c0 3.915-2.506 7.25-6 8.487V48h4a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zm47-9h2V21.945a9.168 9.168 0 0 1-2 0zm9 4v-1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1zM5 54v3a1 1 0 0 0 1 1h52a1 1 0 0 0 1-1v-3zm47.759-34.223A7.007 7.007 0 0 0 58 13c0-3.864-3.137-7-7-7s-7 3.136-7 7a7.004 7.004 0 0 0 8.74 6.781l.019-.004zm.237-6.906a2 2 0 1 1-1.109-1.664l1.558-1.039a1.001 1.001 0 0 1 1.11 1.664zM14 20h22c.796 0 1.559.316 2.121.879.563.562.879 1.325.879 2.121v20c0 .796-.316 1.559-.879 2.121A2.996 2.996 0 0 1 36 46H14a2.996 2.996 0 0 1-2.121-.879A2.996 2.996 0 0 1 11 43V23c0-.796.316-1.559.879-2.121A2.996 2.996 0 0 1 14 20zm7 2h-7a.997.997 0 0 0-1 1v20a.997.997 0 0 0 1 1h22a.997.997 0 0 0 1-1V23a.997.997 0 0 0-1-1h-7l.001 4.131a2 2 0 0 1-3.11 1.665l-.89-.594-.891.594A2 2 0 0 1 21 26.132zm6 0h-4v4.132l.891-.594a2 2 0 0 1 2.219 0l.891.593zm6 16a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0zm-4 0a1 1 0 0 1 2 0v3a1 1 0 0 1-2 0z"
                        opacity={1}
                        data-original="url(#a)"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default PackageWeightIcon